import React, { useEffect, useState, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { withRouter } from 'react-router';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import { tableDataIngestionBatchStatus } from '../helper';
import {
    getDataIngestionBatchStatusData,
    handleLoader
}
    from '../../../redux/actions/DataIngestionBatchStatusAction';
import DataIngestionBatchStatusTable from './DataIngestionBatchStatusTable';

const dummyData = {
    "nextPlannedBatchAt": "15-Feb-2023 12:14:00 UTC",
    "nextBatchRemainingTimeToStart": "16:14:00",
    "batchItems": [
      {
        "BatchID": "20230213",
        "Date": "Feb 13 2023",
        "id": 1,
        "description": "Line Item 1",
        "totalTimeTaken": "02:02:00",
        "status": "Success",
        "recordsProcessed": 7000,
        "batchStartAt": "20023-02-13 12:12:00",
        "batchEndAt": "20023-02-13 14:14:00",
        "markAs": ""
      },
      {
        "BatchID": "20230213",
        "Date": "Feb 13 2023",
        "id": 2,
        "description": "Line Item 2",
        "totalTimeTaken": "03:02:00",
        "status": "Success",
        "recordsProcessed": 12000,
        "batchStartAt": "",
        "batchEndAt": "",
        "markAs": ""
      }
    ]
  }

const DataIngestionBatchStatus = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');

    const { dataIngestionBatchStatusData, salesChannelFilterData, isLoading } = useSelector(
        ({ dataIngestionBatchStatusReducer, marketPlaceReducer }) =>
        ({
            dataIngestionBatchStatusData: dataIngestionBatchStatusReducer.dataIngestionBatchStatusData,
            isLoading: dataIngestionBatchStatusReducer.isLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );

    const previousMonthDate = new Date();
    // previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)
    previousMonthDate.setDate(previousMonthDate.getDate() - 6)

    const [dataIngestionBatchStatusDataToShow, setDataToShow] = useState([])
    const [filterData, setFilterData] = useState({});
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());
    
    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Data Ingestion Batch Status Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const callApi = () => {
        dispatch(handleLoader(true));
        dispatch(getDataIngestionBatchStatusData(
            {
                fromdate: moment(fromDate).format('YYYY-MM-DD'),
                todate: moment(toDate).format('YYYY-MM-DD')
            }
        ));
    }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            callApi()
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }
    }
    // eslint-disable-next-line array-callback-return    

    // eslint-disable-next-line react/prop-types    

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(dataIngestionBatchStatusData?.modal?.data || []);
    }, [dataIngestionBatchStatusData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    const dataToShowForDatesSelected = dataIngestionBatchStatusDataToShow?.filter(item => filterBasedOnFilter(item))
    console.log(dataToShowForDatesSelected)
    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Data Ingestion Batch Status</h5>
                            </div>                            
                            {/* <Row className="align-items-center mt-4">
                                <Col sm="1">
                                    &nbsp;
                                </Col>
                                <Col sm="4">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">
                                            Next Planned Batch At
                                        </span>&nbsp;
                                        <span className="form__form-group-label bold-text">
                                            {dummyData.nextPlannedBatchAt}
                                        </span>
                                    </div>
                                </Col>
                                <Col sm="2">
                                    &nbsp;
                                </Col>
                                <Col sm="5">
                                <div className="form__form-group mb-0">
                                    <span className="form__form-group-label">
                                    Next Batch Remaining Time To Start(hh:mm:ss) 
                                    </span>&nbsp;                                          
                                    <span className="form__form-group-label bold-text">
                                        {dummyData.nextBatchRemainingTimeToStart}
                                    </span>
                                    </div>
                                </Col>                                
                            </Row>                              */}
                            <Row className="align-items-center mt-5">                                
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">From Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                       
                                    </Row>
                                </Col>

                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <DataIngestionBatchStatusTable
                                    data={dataToShowForDatesSelected}
                                    // data={dummyData.batchItems}
                                    tableHeaderData={tableDataIngestionBatchStatus}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>
        </Container>
    );
};

DataIngestionBatchStatus.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
}

export default connect(state => ({
    rtl: state.rtl,
}))(DataIngestionBatchStatus);